import React, { useState } from "react";
import { StyledCouponForm, StyledGotACoupon } from "./plans.style";
import { validateCoupon as _validateCoupon } from "../../services/globalService";
import { ErrorContainer, SuccessContainer } from "../style/global.style";
import SmallLoader from "../utils/SmallLoader";
import { captureException } from "services/sentry";

const CouponInput = ({ applyCoupon, setApplyCoupon, coupon, setCoupon, setCouponObj }) => {
	const [showCouponInput, setShowCouponInput] = useState(false);
	const [success, setSuccess] = useState("");
	const [error, setErr] = useState("");
	const [loading, setLoading] = useState(false);

	const validateCoupon = async () => {
		if (coupon) {
			try {
				const response = await _validateCoupon(coupon);
				if (response?.data) {
					if (response?.data?.valid) {
						setErr("");
						setSuccess("Coupon applied successfully");
						return response.data;
					} else throw new Error("Coupon is expired");
				} else throw new Error(response);
			} catch (e) {
				console.error(e);
				if (e?.status === 404) {
					setErr("Invalid Coupon");
				} else {
					setErr(e?.message);
				}
				captureException(e, "log", {}, { action: "validateCoupon", description: "Validate coupon function was running" }, { scope: "CouponInput.js" });
				return false;
			} finally {
				setLoading(false);
			}
		}
	};

	const handleCouponSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		const couponObj = await validateCoupon();
		if (couponObj) {
			setCouponObj(couponObj);
			setApplyCoupon(true);
		}
	};

	const inputForm = (
		<StyledCouponForm onSubmit={handleCouponSubmit}>
			<input type="text" value={coupon} onChange={(e) => setCoupon(e.target.value)} disabled={applyCoupon} placeholder="Coupon code" />
			<button type="submit" disabled={applyCoupon}>
				{loading ? <SmallLoader inline={true} /> : "Let's go"}
			</button>
			{success ? <SuccessContainer>{success}</SuccessContainer> : null}
			{error ? <ErrorContainer>{error}</ErrorContainer> : null}
		</StyledCouponForm>
	);

	if (showCouponInput) {
		return inputForm;
	} else {
		return <StyledGotACoupon onClick={() => setShowCouponInput(true)}>Got a coupon?</StyledGotACoupon>;
	}
};

export default CouponInput;
